import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { FooterComponent } from '../layouts/footer/footer.component.mjs';
import { HeaderComponent } from '../layouts/header/header.component.mjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, BlockUIModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})

export class LayoutComponent {
  constructor(router: Router) {
    router.navigateByUrl("/home");
  }

}
